import { css } from "styled-components"

export const FontFamilyRegular = css`
  font-family: "HCo Gotham", "Helvetica", "Verdana", "Arial", "sans-serif";
`
export const FontFamilySmartScreen = FontFamilyRegular

const HeadingOneRegular = css`
  /* H1 Desk */

  ${FontFamilyRegular}
  font-style: normal;
  font-weight: 300;
  font-size: 48px;
  line-height: 120%;
  /* identical to box height, or 58px */

  letter-spacing: 0.05em;
  text-transform: uppercase;
`

const HeadingTwoRegular = css`
  /* H2 Desk */

  ${FontFamilyRegular}
  font-style: normal;
  font-weight: 300;
  font-size: 36px;
  line-height: 140%;
  /* or 50px */

  letter-spacing: 0.08em;
  text-transform: uppercase;
`

const HeadingTwoSemiBold = css`
  /* H2 Desk */

  ${FontFamilyRegular}
  font-style: normal;
  font-weight: 400;
  font-size: 36px;
  line-height: 140%;
  /* or 50px */

  letter-spacing: 0.08em;
  text-transform: uppercase;
`

const HeadingTwoBold = css`
  /* H2 Desk */

  ${FontFamilyRegular}
  font-style: normal;
  font-weight: 500;
  font-size: 36px;
  line-height: 140%;
  /* or 50px */

  letter-spacing: 0.08em;
  text-transform: uppercase;
`
const HeadingThreeRegular = css`
  /* H3 Desk - 30px - Book */

  ${FontFamilyRegular}
  font-style: normal;
  font-weight: normal;
  font-size: 30px;
  line-height: 140%;
  /* identical to box height, or 42px */

  letter-spacing: 0.08em;
  text-transform: uppercase;
`

const HeadingThreeBold = css`
  /* H3 Desk - 30px - Med */
  ${HeadingThreeRegular}
  font-weight: 500;
  /* identical to box height, or 42px */
`

const HeadingThreeSemiBold = css`
  /* H3 Desk - 30px - Med */
  ${HeadingThreeRegular}
  font-weight: 500;
  /* identical to box height, or 42px */
`
const HeadingFourRegular = css`
  /* H4 Desk */

  ${FontFamilyRegular}
  font-style: normal;
  font-weight: 300;
  font-size: 24px;
  line-height: 120%;
  /* identical to box height, or 22px */

  letter-spacing: 0.08em;
  text-transform: uppercase;
`
const HeadingFourSemiBold = css`
  ${HeadingFourRegular}
  font-weight: 400;
`
const HeadingFourBold = css`
  ${HeadingFourRegular}
  font-weight: 500;
`
const HeadingFiveRegular = css`
  /* H5 Desk */

  ${FontFamilyRegular}
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 120%;
  /* or 19px */

  letter-spacing: 0.05em;
  text-transform: uppercase;
`

const HeadingSixRegular = css`
  /* H6 Desk */

  ${FontFamilyRegular}
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 160%;
  /* or 22px */

  letter-spacing: 0.08em;
  text-transform: uppercase;
`

const BodyText18 = css`
  /* Body 18px */

  ${FontFamilyRegular}
  font-style: normal;
  font-weight: 300;
  font-size: 18px;
  line-height: 170%;
  /* or 31px */
`

const BodyText16 = css`
  /* Body 16px */

  ${BodyText18}
  font-size: 16px;
`

const BodyText20 = css`
  ${BodyText18}
  font-size: 20px;
`

const LinkText = css`
  ${FontFamilyRegular}
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  line-height: 130%;
`

const FooterHeadingOne = css`
  ${FontFamilyRegular}
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 150%;
`
const FooterHeadingTwo = css`
  ${FontFamilyRegular}
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  /* identical to box height */

  letter-spacing: 0.128em;
  text-transform: uppercase;
`

const FooterBodyText = css`
  ${FontFamilyRegular}
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  /* line height set by element */
`

const FooterBodyTextSmall = css`
  ${FontFamilyRegular}
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 170%;
  /* or 20px */
  opacity: 0.75;
`

const MobileHeadingOneRegular = css`
  /* H1 Mobile */

  ${FontFamilySmartScreen}
  font-style: normal;
  font-size: 30px;
  line-height: 140%;
  font-weight: 300;
  /* identical to box height, or 42px */

  letter-spacing: 0.08em;
  text-transform: uppercase;
`

const MobileHeadingOneBold = css`
  /* H1 Mobile */

  ${FontFamilySmartScreen}
  font-style: normal;
  font-size: 30px;
  line-height: 140%;
  font-weight: 500;
  /* identical to box height, or 42px */

  letter-spacing: 0.08em;
  text-transform: uppercase;
`

const MobileHeadingOneSemiBold = css`
  /* H1 Mobile */

  ${FontFamilySmartScreen}
  font-style: normal;
  font-size: 30px;
  line-height: 140%;
  font-weight: 400;
  /* identical to box height, or 42px */

  letter-spacing: 0.08em;
  text-transform: uppercase;
`

const MobileHeadingTwoBold = css`
  /* H2 Mobile Bold */

  ${FontFamilySmartScreen}
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 140%;
  /* identical to box height, or 34px */

  letter-spacing: 0.05em;
  text-transform: uppercase;
`

const MobileHeadingTwoSemiBold = css`
  /* H2 Mobile - Med */

  ${FontFamilySmartScreen}
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 140%;
  /* identical to box height, or 34px */

  letter-spacing: 0.05em;
  text-transform: uppercase;
`

const MobileHeadingTwoRegular = css`
  /* H2 Mobile Reg */

  ${FontFamilySmartScreen}
  font-style: normal;
  font-weight: 300;
  font-size: 24px;
  line-height: 140%;
  /* identical to box height, or 34px */

  letter-spacing: 0.05em;
  text-transform: uppercase;
`

const MobileHeadingThreeRegular = css`
  /* H3 - Mobile Med */

  ${FontFamilySmartScreen}
  font-style: normal;
  font-weight: 300;
  font-size: 18px;
  line-height: 130%;
  /* or 23px */

  letter-spacing: 0.08em;
  text-transform: uppercase;
`
const MobileHeadingThreeBold = css`
  /* H3 - Mobile Med */

  ${FontFamilySmartScreen}
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 130%;
  /* or 23px */

  letter-spacing: 0.08em;
  text-transform: uppercase;
`

const MobileHeadingThreeSemiBold = css`
  ${MobileHeadingThreeRegular}
  font-weight: 400;
`

const MobileHeadingFourRegular = css`
  /* H6 Desk */

  ${FontFamilySmartScreen}
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 160%;
  /* or 22px */

  letter-spacing: 0.08em;
  text-transform: uppercase;
`

const MobileHeadingFourBold = css`
  ${MobileHeadingFourRegular}
  font-weight: 500;
`

const MobileSubHeading = css`
  ${FontFamilySmartScreen}
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 120%;
  /* or 19px */

  text-align: center;
  letter-spacing: 0.05em;
  text-transform: uppercase;
`

const MobileBodyRegular = css`
  /* Body 18px */

  ${FontFamilySmartScreen}
  font-style: normal;
  font-weight: 300;
  font-size: 18px;
  line-height: 170%;
  /* or 31px */
`

const TabletHeadingOneRegular = css`
  ${FontFamilySmartScreen}
  font-style: normal;
  font-weight: normal;
  font-size: 36px;
  line-height: 140%;
  /* or 50px */

  letter-spacing: 0.08em;
  text-transform: uppercase;
`
const TabletHeadingTwoRegular = css`
  ${FontFamilySmartScreen}
  font-style: normal;
  font-weight: 300;
  font-size: 24px;
  line-height: 140%;
  /* identical to box height, or 34px */

  letter-spacing: 0.08em;
  text-transform: uppercase;
`
const TabletHeadingTwoSemiBold = css`
  ${FontFamilySmartScreen}
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 140%;
  /* identical to box height, or 34px */

  letter-spacing: 0.05em;
  text-transform: uppercase;
`
const TabletHeadingTwoBold = css`
  ${TabletHeadingTwoRegular}
  font-weight: 500;
`
const TabletHeadingThreeRegular = css`
  ${FontFamilySmartScreen}
  font-style: normal;
  font-weight: 300;
  font-size: 20px;
  line-height: 140%;
  /* identical to box height, or 28px */

  letter-spacing: 0.08em;
  text-transform: uppercase;
`
const TabletHeadingThreeSemiBold = css`
  ${TabletHeadingThreeRegular}
  font-weight: 400;
`
const TabletHeadingThreeBold = css`
  ${TabletHeadingThreeRegular}
  font-weight: 500;
`

const TabletHeadingFourRegular = css`
  ${FontFamilySmartScreen}
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 120%;
  /* or 19px */

  text-align: center;
  letter-spacing: 0.08em;
  text-transform: uppercase;
`

const TabletBodyRegular = css`
  /* Body 16px */

  ${FontFamilySmartScreen}
  font-style: normal;
  font-size: 16px;
  line-height: 170%;

  text-transform: none;
  font-weight: 300;
  letter-spacing: unset;
  /* or 31px */
`

const TabletSubHeading = css`
  ${FontFamilySmartScreen}
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 160%;
  /* or 19px */

  letter-spacing: 0.08em;
  text-transform: uppercase;
`

export const desktopTextStyles = {
  HeadingOneRegular,
  HeadingTwoRegular,
  HeadingTwoSemiBold,
  HeadingTwoBold,
  HeadingThreeRegular,
  HeadingThreeBold,
  HeadingFourRegular,
  HeadingFourSemiBold,
  HeadingFourBold,
  HeadingFiveRegular,
  HeadingSixRegular,
  BodyText16,
  BodyText18,
  BodyText20,
  LinkText,
  FooterHeadingOne,
  FooterHeadingTwo,
  FooterBodyText,
  FooterBodyTextSmall,
}

export const mobileTextStyles = {
  MobileHeadingOneRegular,
  MobileHeadingOneBold,
  MobileHeadingOneSemiBold,
  MobileHeadingTwoBold,
  MobileHeadingTwoSemiBold,
  MobileHeadingTwoRegular,
  MobileHeadingThreeRegular,
  MobileHeadingThreeBold,
  MobileHeadingFourRegular,
  MobileHeadingFourBold,
  MobileBodyRegular,
  MobileSubHeading,
}

export const tabletTextStyles = {
  TabletHeadingOneRegular,
  TabletHeadingTwoRegular,
  TabletHeadingTwoSemiBold,
  TabletHeadingTwoBold,
  TabletHeadingThreeRegular,
  TabletHeadingThreeBold,
  TabletHeadingFourRegular,
  TabletBodyRegular,
  TabletSubHeading,
}

export const T = {
  sm: {
    body: {
      regular: MobileBodyRegular,
    },
    h1: {
      regular: MobileHeadingOneRegular,
      semiBold: MobileHeadingOneSemiBold,
    },
    h2: {
      regular: MobileHeadingTwoRegular,
      semiBold: MobileHeadingTwoSemiBold,
      bold: MobileHeadingTwoBold,
    },
    h3: {
      regular: MobileHeadingThreeRegular,
      semiBold: MobileHeadingThreeSemiBold,
      bold: MobileHeadingThreeBold,
    },
    h4: {
      regular: MobileHeadingFourRegular,
      bold: MobileHeadingFourBold,
    },
    misc: {
      subheading: MobileSubHeading,
    },
  },
  md: {
    body: {
      regular: TabletBodyRegular,
    },
    h1: {
      regular: TabletHeadingOneRegular,
    },
    h2: {
      regular: TabletHeadingTwoRegular,
      semiBold: TabletHeadingTwoSemiBold,
      bold: TabletHeadingTwoBold,
    },
    h3: {
      regular: TabletHeadingThreeRegular,
      semiBold: TabletHeadingThreeSemiBold,
      bold: TabletHeadingThreeBold,
    },
    h4: {
      regular: TabletHeadingFourRegular,
    },
    misc: {
      subheading: TabletSubHeading,
    },
  },
  lg: {
    body: {
      regular: BodyText18,
      regular16: BodyText16,
      regular18: BodyText18,
      regular20: BodyText20,
    },
    h1: {
      regular: HeadingOneRegular,
    },
    h2: {
      regular: HeadingTwoRegular,
      semiBold: HeadingTwoSemiBold,
      bold: HeadingTwoBold,
    },
    h3: {
      regular: HeadingThreeRegular,
      bold: HeadingThreeBold,
      semiBold: HeadingThreeSemiBold,
    },
    h4: {
      regular: HeadingFourRegular,
      semiBold: HeadingFourSemiBold,
      bold: HeadingFourBold,
    },
    h5: {
      regular: HeadingFiveRegular,
    },
    h6: {
      regular: HeadingSixRegular,
    },
    misc: {
      linkText: LinkText,
    },
  },
  footer: {
    body: {
      regular: FooterBodyText,
      small: FooterBodyTextSmall,
    },
    h1: {
      regular: FooterHeadingOne,
    },
    h2: {
      regular: FooterHeadingTwo,
    },
  },
}

export default { mobileTextStyles, tabletTextStyles, desktopTextStyles }
